// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* YovoTripHeader - Responsive & iOS/Safari-safe Styles
 * Uses global tokens from yovo-tokens.css (imported via index.css)
 *
 * IMPORTANT: Position, padding, background, z-index are set via MUI sx prop
 * in the JSX. This CSS only handles browser-specific fixes, responsive
 * display toggling, and iOS hardening that can't be done in sx.
 */

/* Profile cluster (header auth) — iOS / touch */
.yovo-header-profile-cluster {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

@media (hover: none) and (pointer: coarse) {
  .yovo-header-profile-cluster--logged-in {
    min-height: 44px;
  }
}

/* ===== iOS text & tap resets (no layout impact) ===== */
.yovo-header {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  text-size-adjust: 100%;
}

.yovo-header *,
.yovo-header *::before,
.yovo-header *::after {
  text-size-adjust: 100%;
  box-sizing: border-box;
}

/* ===== Search bar: inline on desktop, collapsible on mobile/tablet ===== */
.yovo-header-search-inline {
  display: none;
}

.yovo-header-search-icon {
  display: flex;
}

/* ===== Input zoom prevention for iOS (Safari zooms on <16px inputs) ===== */
.yovo-header-search-input input,
.yovo-header input[type="text"],
.yovo-header input[type="search"] {
  font-size: var(--yovo-text-md) !important;
  appearance: none;
}

@media (min-width: 1000px) {
  .yovo-header-search-input input {
    font-size: var(--yovo-text-base) !important;
  }
}

/* ===== Smooth scrolling for dropdown (iOS momentum scroll) ===== */
.yovo-header-search-dropdown {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  -webkit-overscroll-behavior: contain;
}

.yovo-header-search-dropdown > div {
  -webkit-overflow-scrolling: touch;
}

/* ===== Touch-friendly tap targets only on touch devices ===== */
@media (hover: none) and (pointer: coarse) {
  .yovo-header-nav [role="button"],
  .yovo-header-nav > div {
    min-height: var(--yovo-tap-min);
  }
}

/* ===== Mobile + Tablet (<1000px): hide nav, show search icon ===== */
@media (max-width: 999.98px) {
  .yovo-header-nav {
    display: none !important;
  }

  .yovo-header-search-inline {
    display: none !important;
  }

  .yovo-header-search-icon {
    display: flex !important;
  }
}

/* ===== Desktop (1000px+): inline heritage search + hide redundant icon control ===== */
@media (min-width: 1000px) {
  .yovo-header-search-inline {
    display: flex !important;
    flex: 1 1;
    min-width: 0;
  }

  .yovo-header-search-icon {
    display: none !important;
  }
}

/* ===== iOS safe area (only on actual notched devices in standalone/PWA) ===== */
@supports (padding-top: env(safe-area-inset-top)) {
  @media (display-mode: standalone) {
    .yovo-header {
      padding-top: env(safe-area-inset-top);
    }
  }
}

@supports (padding-left: env(safe-area-inset-left)) {
  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
    .yovo-header {
      padding-left: max(var(--yovo-space-base), env(safe-area-inset-left));
      padding-right: max(var(--yovo-space-base), env(safe-area-inset-right));
    }
  }
}

/* ===== Landscape phone (short viewport, touch only) ===== */
@media (max-height: 500px) and (orientation: landscape) and (hover: none) {
  .yovo-header {
    padding-top: var(--yovo-space-sm);
    padding-bottom: var(--yovo-space-sm);
  }
}

/* ===== iOS Safari-specific flexbox fixes ===== */
@supports (-webkit-touch-callout: none) {
  .yovo-header {
    position: -webkit-sticky;
  }

  .yovo-header-search-inline {
    flex-shrink: 1;
    min-width: 0;
  }
}

/* Narrow desktop: cap inline search so it cannot grow back into logo + tabs */
@media (min-width: 1000px) and (max-width: 1199.98px) {
  .yovo-header-search-inline {
    max-width: min(420px, calc(100vw - 28rem)) !important;
  }
}

/* 1px line below header; IntersectionObserver uses it to know when user has scrolled past */
.yovo-header-scroll-sentinel {
  width: 100%;
  height: 1px;
  margin: 0;
  padding: 0;
  border: 0;
  flex-shrink: 0;
  pointer-events: none;
  opacity: 0;
}

/* ===== Scroll-triggered red header state ===== */
.yovo-header--scrolled {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

/* ===== High DPI / Retina ===== */
@media (min-resolution: 192dpi) {
  .yovo-header img {
    image-rendering: -webkit-optimize-contrast;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/styles/YovoTripHeader.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF,gDAAgD;AAChD;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yDAAyD;AACzD;EACE,wCAAwC;EACxC,2BAA2B;EAE3B,sBAAsB;AACxB;;AAEA;;;EAIE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;AACf;;AAEA,6EAA6E;AAC7E;;;EAGE,yCAAyC;EAEzC,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA,oEAAoE;AACpE;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iEAAiE;AACjE;EACE;;IAEE,+BAA+B;EACjC;AACF;;AAEA,sEAAsE;AACtE;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IAEE,wBAAwB;EAC1B;AACF;;AAEA,wFAAwF;AACxF;EACE;IAEE,wBAAwB;IAExB,SAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,iFAAiF;AACjF;EACE;IACE;MACE,qCAAqC;IACvC;EACF;AACF;;AAEA;EACE;IACE;MACE,oEAAoE;MACpE,sEAAsE;IACxE;EACF;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,iCAAiC;IACjC,oCAAoC;EACtC;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IAEE,cAAc;IACd,YAAY;EACd;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,qDAAqD;EACvD;AACF;;AAEA,4FAA4F;AAC5F;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,0CAA0C;AAC5C;;AAEA,kCAAkC;AAClC;EACE;IACE,0CAA0C;EAC5C;AACF","sourcesContent":["/* YovoTripHeader - Responsive & iOS/Safari-safe Styles\n * Uses global tokens from yovo-tokens.css (imported via index.css)\n *\n * IMPORTANT: Position, padding, background, z-index are set via MUI sx prop\n * in the JSX. This CSS only handles browser-specific fixes, responsive\n * display toggling, and iOS hardening that can't be done in sx.\n */\n\n/* Profile cluster (header auth) — iOS / touch */\n.yovo-header-profile-cluster {\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n@media (hover: none) and (pointer: coarse) {\n  .yovo-header-profile-cluster--logged-in {\n    min-height: 44px;\n  }\n}\n\n/* ===== iOS text & tap resets (no layout impact) ===== */\n.yovo-header {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\n.yovo-header *,\n.yovo-header *::before,\n.yovo-header *::after {\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  box-sizing: border-box;\n}\n\n/* ===== Search bar: inline on desktop, collapsible on mobile/tablet ===== */\n.yovo-header-search-inline {\n  display: none;\n}\n\n.yovo-header-search-icon {\n  display: -webkit-flex;\n  display: flex;\n}\n\n/* ===== Input zoom prevention for iOS (Safari zooms on <16px inputs) ===== */\n.yovo-header-search-input input,\n.yovo-header input[type=\"text\"],\n.yovo-header input[type=\"search\"] {\n  font-size: var(--yovo-text-md) !important;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n@media (min-width: 1000px) {\n  .yovo-header-search-input input {\n    font-size: var(--yovo-text-base) !important;\n  }\n}\n\n/* ===== Smooth scrolling for dropdown (iOS momentum scroll) ===== */\n.yovo-header-search-dropdown {\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  -webkit-overscroll-behavior: contain;\n}\n\n.yovo-header-search-dropdown > div {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ===== Touch-friendly tap targets only on touch devices ===== */\n@media (hover: none) and (pointer: coarse) {\n  .yovo-header-nav [role=\"button\"],\n  .yovo-header-nav > div {\n    min-height: var(--yovo-tap-min);\n  }\n}\n\n/* ===== Mobile + Tablet (<1000px): hide nav, show search icon ===== */\n@media (max-width: 999.98px) {\n  .yovo-header-nav {\n    display: none !important;\n  }\n\n  .yovo-header-search-inline {\n    display: none !important;\n  }\n\n  .yovo-header-search-icon {\n    display: -webkit-flex !important;\n    display: flex !important;\n  }\n}\n\n/* ===== Desktop (1000px+): inline heritage search + hide redundant icon control ===== */\n@media (min-width: 1000px) {\n  .yovo-header-search-inline {\n    display: -webkit-flex !important;\n    display: flex !important;\n    -webkit-flex: 1 1 0%;\n    flex: 1 1 0%;\n    min-width: 0;\n  }\n\n  .yovo-header-search-icon {\n    display: none !important;\n  }\n}\n\n/* ===== iOS safe area (only on actual notched devices in standalone/PWA) ===== */\n@supports (padding-top: env(safe-area-inset-top)) {\n  @media (display-mode: standalone) {\n    .yovo-header {\n      padding-top: env(safe-area-inset-top);\n    }\n  }\n}\n\n@supports (padding-left: env(safe-area-inset-left)) {\n  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {\n    .yovo-header {\n      padding-left: max(var(--yovo-space-base), env(safe-area-inset-left));\n      padding-right: max(var(--yovo-space-base), env(safe-area-inset-right));\n    }\n  }\n}\n\n/* ===== Landscape phone (short viewport, touch only) ===== */\n@media (max-height: 500px) and (orientation: landscape) and (hover: none) {\n  .yovo-header {\n    padding-top: var(--yovo-space-sm);\n    padding-bottom: var(--yovo-space-sm);\n  }\n}\n\n/* ===== iOS Safari-specific flexbox fixes ===== */\n@supports (-webkit-touch-callout: none) {\n  .yovo-header {\n    position: -webkit-sticky;\n  }\n\n  .yovo-header-search-inline {\n    -webkit-flex-shrink: 1;\n    flex-shrink: 1;\n    min-width: 0;\n  }\n}\n\n/* Narrow desktop: cap inline search so it cannot grow back into logo + tabs */\n@media (min-width: 1000px) and (max-width: 1199.98px) {\n  .yovo-header-search-inline {\n    max-width: min(420px, calc(100vw - 28rem)) !important;\n  }\n}\n\n/* 1px line below header; IntersectionObserver uses it to know when user has scrolled past */\n.yovo-header-scroll-sentinel {\n  width: 100%;\n  height: 1px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  flex-shrink: 0;\n  pointer-events: none;\n  opacity: 0;\n}\n\n/* ===== Scroll-triggered red header state ===== */\n.yovo-header--scrolled {\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* ===== High DPI / Retina ===== */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .yovo-header img {\n    image-rendering: -webkit-optimize-contrast;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
